import http from 'common/http'

export async function getFeatureFlags() {
  return http.get('/feature-flag')
}
